module.exports = __webpack_public_path__ + "img/127.9.abf2b80a.png";